import * as React from 'react';

import classNames from 'classnames';

import { ICompilationDescriptionProps } from './types';

import * as s from './CompilationDescription.scss';

export const CompilationDescription: React.FC<ICompilationDescriptionProps> = (props: ICompilationDescriptionProps ) => {
	const {
		className,
		children,
	} = props;

	return (
		<div className={classNames(s.block, className)}>
			{ children }
		</div>
	);
};
